<template>
<div class="page">
    <b-card class="mb-2">
        <b-spinner class="align-middle"></b-spinner>
        <div class="text-center">
            載入中...
        </div>
    </b-card>
</div>
</template>
<script>
import abbottAndMixin from "@/mixins/liff/proj/abbott-and";
import { mapActions, mapGetters } from 'vuex';
import liff from "@line/liff";

export default {
  mixins: [abbottAndMixin],
  components: {},
  async mounted() {

    console.log("[AND RecordQuery] ========== RecordQuery.vue mounted() ==========");
    console.log("[AND RecordQuery] LIFF ID (from store):", this.storeLiffId);
    console.log("[AND RecordQuery] LIFF ID (from liff.id):", liff.id);
    console.log("[AND RecordQuery] LIFF isInClient:", liff.isInClient?.());
    console.log("[AND RecordQuery] LIFF isLoggedIn:", liff.isLoggedIn?.());
    console.log("[AND RecordQuery] Route params:", this.$route.params);
    console.log("[AND RecordQuery] Route query:", this.$route.query);
    console.log("[AND RecordQuery] couponType:", this.$route.params.couponType);

    const query = this.$route.query;
    const queryData = {
      phone: query.phone,
      source: query.source,
      coupon_code: query.couponCode,
      qrcode: query.Id,
      store_code: query.storeCode,
      brand: query.brand,
      event_name: query.eventName,
      need_bind_store: query.need_bind_store,
      type: this.$route.params.couponType
    };
    console.log("[AND RecordQuery] Setting query data:", queryData);

    this.setQuery(queryData);
    this.init();
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      queryData: "projAbbottAnd/queryData",
      couponType: "projAbbottAnd/couponType",
      storeLiffId: "liffGeneral/liffId",
    }),
  },
  methods: {
    ...mapActions('projAbbottAnd', ['setQuery']),
    init() {
      console.log("[AND RecordQuery] init() -> calling checkMember()");
      this.checkMember()
    },
  }
}
</script>

<style lang="scss"></style>
